import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "date", "list", "dividerRef"],
  _excluded2 = ["message"];
import React, { forwardRef } from 'react';
import { cnBem } from "../../../../shared/lib";
import { Divider } from "../../../../shared/ui";
import { Message } from "../../../../features/message/ui";
import styles from "./styles.pcss";
var cnMessageListGroup = cnBem('message-group', styles);
export var MessageGroup = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
    date = props.date,
    list = props.list,
    dividerRef = props.dividerRef,
    otherProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement("section", _extends({
    className: cnMessageListGroup(null, [className]),
    ref: ref
  }, otherProps, {
    "data-t-id": "ui-MessageGroup"
  }), /*#__PURE__*/React.createElement(Divider, {
    className: cnMessageListGroup('date'),
    dateTime: date,
    label: date,
    ref: dividerRef,
    tagName: "time",
    view: "accent"
  }), list.map(function (_ref) {
    var message = _ref.message,
      params = _objectWithoutProperties(_ref, _excluded2);
    return /*#__PURE__*/React.createElement(Message, _extends({
      key: message.messageId,
      message: message
    }, params));
  }));
});